// ============================================================
// SectionHeader — Brand Guide v2
//
//   ── SQUARE CODE · HOSTING
//
// Colored dash + JetBrains Mono 11px/700/3-4px letter-spacing
// uppercase label. One accent per section (Brand Guide rule).
// Optionally renders a body title beneath the kicker using the
// page-title or section-title scale.
// ============================================================

export default function SectionHeader({
  accent = '#E8854A',
  kicker,
  title,
  description,
  as = 'section',          // 'page' | 'section'
  align = 'left',
  style: styleOverride,
}) {
  const titleStyle =
    as === 'page'
      ? {
          fontSize: 32,
          fontWeight: 200,
          letterSpacing: '-0.03em',
          color: 'var(--sc-text-primary, #edf2ff)',
          fontFamily: 'var(--sc-font-ui, var(--font-body))',
          lineHeight: 1.1,
          margin: 0,
        }
      : {
          fontSize: 22,
          fontWeight: 300,
          letterSpacing: '-0.022em',
          color: 'var(--sc-text-primary, #edf2ff)',
          fontFamily: 'var(--sc-font-ui, var(--font-body))',
          lineHeight: 1.2,
          margin: 0,
        }

  return (
    <header
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: align === 'center' ? 'center' : 'flex-start',
        gap: 8,
        marginBottom: 18,
        ...styleOverride,
      }}
    >
      {kicker && (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <span
            aria-hidden
            style={{
              display: 'inline-block',
              width: 16,
              height: 2,
              background: accent,
              opacity: 0.4,
              borderRadius: 1,
            }}
          />
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.28em',
              textTransform: 'uppercase',
              color: accent,
              fontFamily: 'var(--sc-font-mono, var(--font-mono))',
            }}
          >
            {kicker}
          </span>
        </div>
      )}
      {title && <h1 style={titleStyle}>{title}</h1>}
      {description && (
        <p
          style={{
            fontSize: 15,
            fontWeight: 400,
            color: 'var(--sc-text-secondary, #9ca8c0)',
            fontFamily: 'var(--sc-font-ui, var(--font-body))',
            margin: 0,
            lineHeight: 1.5,
            maxWidth: 720,
          }}
        >
          {description}
        </p>
      )}
    </header>
  )
}
